import styled from 'styled-components';

import { gradeColourBackground } from 'theme/GlobalStyle';

import { AssessmentCounterGrade } from './types';

export const AssessmentCounterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const AssessmentCounter = styled.div<AssessmentCounterGrade>`
  display: flex;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  height: ${({ theme }) => theme.yoga.spacing.large}px;
  margin-right: ${({ theme, grade }) => grade && theme.yoga.spacing.xxsmall}px;
  ${gradeColourBackground}
`;

export const AssessmentCounterNumber = styled.p`
  text-indent: ${({ theme }) => theme.yoga.spacing.zero};
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const InfoContainer = styled.div`
  display: flex;
  fill: ${({ theme }) => theme.yoga.colors.textSecondary};
`;
